<template>
  <div class="usageweek-machine-list">
    <!-- 过滤 -->
    <div class="table-list">
      <div class="header">
        <div class="search-content">
          <el-form :inline="true" @submit.native.prevent>
            <!-- <el-form-item style="float: right; margin-right: 0">
              <custom-column ref="column"></custom-column>
            </el-form-item> -->
            <el-form-item style="float: right" v-if="funcView.usageweek_site_export">
              <el-button class="custom-btn" icon="icon icon-export-excel left-icon" type="info" round
                @click="exportRecord">{{ $t('com_export') }}</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <i class="icon icon-shaixuan icon-filter" @click="isFilter = !isFilter"></i>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 过滤 -->
      <div class="query-filter" style="margin-top: 24px; width: 100%; padding: 0" >
        <div class="params-form"  v-show="isFilter">
          <el-row :gutter="23">
            <el-col :span="8" v-if="isCoJv && showSubsidiary">
              <div class="item">
                <div class="label">{{ $t('um_list_gsmc') }}</div>
                <div class="value">
                  <el-input v-model="formSearch.customerName" @input="onPageChange({ page: 1 })" clearable  :placeholder="$t('com_please_input')"></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{`${$t('um_list_xmqymcjsh')}`}}</div>
                <div class="value">
                  <el-input v-model="formSearch.search" @input="onPageChange({ page: 1 })" clearable
                    :placeholder="$t('com_please_input')"></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('um_list_suo_shu_bu_men') }}</div>
                <div class="value">
                  <custom-select
                    url="DepartmentTree"
                    v-model="formSearch.departmentId"
                    :model="formSearch"
                    :props="{ label: 'bizName', value: 'bizId',checkStrictly: true,map: { bizName: 'departmentName' } }"
                    :params="{ isCountDevice:1 }"
                    :placeholder="$t('com_please_select')"
                    width="100%"
                    ref="tag"
                    type="tree"
                    filterable
                    :dataFilter="departmentTreeFilter"
                    @treeValChange="onPageChange({ page: 1 })"
                    @treeValChangeLabel="onDepartmentLabel"
                    @getList="onDepartmentList"
                    :clearable="false"
                  ></custom-select>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="filter-values">
          <div class="label">{{ $t('um_list_shai_xuan_xiang') }}：</div>
          <div class="values">
            <el-tag v-if="formSearch.customerName" closable @close="
              formSearch.customerName = '';
              onPageChange({ page: 1 });
            ">
              {{ formSearch.customerName }}
            </el-tag>
            <el-tag v-if="formSearch.search" closable @close="
              formSearch.search = '';
              onPageChange({ page: 1 });
            ">
              {{ formSearch.search }}
            </el-tag>
            <el-tag
              v-if="formSearch.departmentId"
              closable
              @close="
                formSearch.departmentId = '';
                formSearch.departmentName = '';
                onPageChange({ page: 1 });
              "
            >
              {{ formSearch.departmentName }}
            </el-tag>
            <span class="clear" @click="onClear">{{ $t('com_clear') }}</span>
          </div>
        </div>
      </div>
      <div class="table-bd">
        <custom-table v-if="isUs" tableCode="usage_week_ft" height="500px" :data="tableList" :index="true"
          @sort="sortChange" @column="setColumn" @filter="filterChange"
          :filterArr="filterArr"
           :slots="['cleanAreaAvg2','cleanArea1','usageTimeAvg2','usageTime1','cleanScoreRate','cleanAreaRate','usageTimeRate']"
           width="100%"
           :key="3"
          >
          <!--
            manualCleanArea
            autonomousCleanArea
            trainingCleanArea
          -->
          <template v-slot:cleanAreaAvg2="scope">
            <span>{{scope.row.cleanAreaAvg2>0?$numCommaSplit($formatLenLocal(scope.row.cleanAreaAvg2)):scope.row.cleanAreaAvg2}}</span>
          </template>
          <template v-slot:cleanArea1="scope">
            <span>{{scope.row.cleanArea1>0?$numCommaSplit($formatLenLocal(scope.row.cleanArea1)):scope.row.cleanArea1}}</span>
          </template>
          <template v-slot:usageTimeAvg2="scope">
            <span>{{scope.row.usageTimeAvg2>0?$formatSecToHh(scope.row.usageTimeAvg2):scope.row.usageTimeAvg2}}</span>
          </template>
          <template v-slot:usageTime1="scope">
            <span>{{scope.row.usageTime1>0?$formatSecToHh(scope.row.usageTime1):scope.row.usageTime1}}</span>
          </template>
          <template v-slot:cleanScoreRate="scope">
            <span>{{scope.row.cleanScoreRate?`${Math.round(scope.row.cleanScoreRate)}%`:scope.row.cleanScoreRate}}</span>
          </template>
          <template v-slot:cleanAreaRate="scope">
            <span>{{scope.row.cleanAreaRate?`${Math.round(scope.row.cleanAreaRate)}%`:scope.row.cleanAreaRate}}</span>
          </template>
          <template v-slot:usageTimeRate="scope">
            <span>{{scope.row.usageTimeRate?`${Math.round(scope.row.usageTimeRate)}%`:scope.row.usageTimeRate}}</span>
          </template>
        </custom-table>
        <custom-table v-else tableCode="usage_week" height="500px" :filterArr="filterArr" :data="tableList" :index="true" @sort="sortChange"
          @column="setColumn" @filter="filterChange"
           width="100%"
           :slots="['cleanAreaAvg2','cleanArea1','usageTimeAvg2','usageTime1','cleanScoreRate','cleanAreaRate','usageTimeRate']"
           :key="4"
          >
          <template v-slot:cleanAreaAvg2="scope">
            <span>{{scope.row.cleanAreaAvg2>0?$numCommaSplit($formatLenLocal(scope.row.cleanAreaAvg2)):scope.row.cleanAreaAvg2}}</span>
          </template>
          <template v-slot:cleanArea1="scope">
            <span>{{scope.row.cleanArea1>0?$numCommaSplit($formatLenLocal(scope.row.cleanArea1)):scope.row.cleanArea1}}</span>
          </template>
          <template v-slot:usageTimeAvg2="scope">
            <span>{{scope.row.usageTimeAvg2>0?$formatSecToHh(scope.row.usageTimeAvg2):scope.row.usageTimeAvg2}}</span>
          </template>
          <template v-slot:usageTime1="scope">
            <span>{{scope.row.usageTime1>0?$formatSecToHh(scope.row.usageTime1):scope.row.usageTime1}}</span>
          </template>
          <template v-slot:cleanScoreRate="scope">
            <span>{{scope.row.cleanScoreRate?`${Math.round(scope.row.cleanScoreRate)}%`:scope.row.cleanScoreRate}}</span>
          </template>
          <template v-slot:cleanAreaRate="scope">
            <span>{{scope.row.cleanAreaRate?`${Math.round(scope.row.cleanAreaRate)}%`:scope.row.cleanAreaRate}}</span>
          </template>
          <template v-slot:usageTimeRate="scope">
            <span>{{scope.row.usageTimeRate?`${Math.round(scope.row.usageTimeRate)}%`:scope.row.usageTimeRate}}</span>
          </template>
        </custom-table>
      </div>
      <div class="table-footer">
        <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
      </div>
    </div>
  </div>

  <!-- </div> -->
</template>

<script>
import apis from '@/utils/apis';

// um_list_gsmc: 公司名称// um_list_xmqymcjsh: 项目/区域名称/机身号// um_list_suo_shu_bu_men: 所属部门// um_list_shai_xuan_xiang: 筛选项

export default {
  name: 'usageweek-machine-list',
  components: {},
  computed: {
    filterArr() {
      // 权限
      // 机器 - 列表  usageweek_machine_list
      // 机器 - 导出 usageweek_machine_export
      // 机器 - 清洁面积 usageweek_machine_cleanArea
      // 机器 - 清洁时长 usageweek_machine_cleanTime
      // 机器 - 清洁天数  usageweek_machine_cleanDay


      // 表格列
      // + 机身号  bodyNum
      // - 平均达标次数（前三周）  meetGoalAvg2
      // - 达标次数（上周）meetGoalCount1
      // - 达标次数变化 meetGoalRate
      // - 平均清洁得分（前三周）cleanScoreAvg2
      // - 清洁得分（上周）cleanScore1
      // - 清洁得分变化率 cleanScoreRate
      const arr = ['meetGoalAvg2', 'meetGoalCount1', 'meetGoalRate', 'cleanScoreAvg2', 'cleanScore1', 'cleanScoreRate'];
      if (Object.keys(this.funcView).length && !this.funcView.usageweek_machine_cleanArea) {
        arr.push('cleanAreaAvg2');
        arr.push('cleanArea1');
        arr.push('cleanAreaRate');
      }
      if (Object.keys(this.funcView).length && !this.funcView.usageweek_machine_cleanTime) {
        arr.push('usageTimeAvg2');
        arr.push('usageTime1');
        arr.push('usageTimeRate');
      }
      if (Object.keys(this.funcView).length && !this.funcView.usageweek_machine_cleanDay) {
        arr.push('cleanDaysAvg2');
        arr.push('cleanDays1');
        arr.push('cleanDaysRate');
      }
      if (!this.isCoJv) {
        arr.push('customerName');
      }
      return arr;
    }
  },
  data() {
    return {
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        bodyNum: '',
        startTime: '',
        endTime: '',
        customerName: '',
        search: '',
        showSubsidiary: '',
        departmentId: '',
        departmentName: ''
      },
      totalRows: null,
      tableList: [],
      isFilter: false,
    };
  },
  watch: {

  },
  // created() {

  // },
  mounted() {
    this.mergeLanguage(null, 'portal_usageweek_machine_list');
    this.getFuncView();
    this.getReportPage();
  },
  methods: {
    departmentTreeFilter(obj) {
      const ret = [obj];
      const ret2 = this.removeEmptyChildren(ret);
      return ret2;
    },
    removeEmptyChildren(nodes) {
      return nodes.map((item) => {
        // 如果 children 存在且是空数组，则删除 children 属性
        if (Array.isArray(item.children) && item.children.length === 0) {
          const newItem = { ...item }; // 创建一个新的对象，避免直接修改原数据
          delete newItem.children; // 删除 children 属性
          return newItem; // 返回没有 children 属性的对象
        }

        // 如果有子节点，递归调用 removeEmptyChildren
        if (item.children && item.children.length > 0) {
          return { ...item, children: this.removeEmptyChildren(item.children) };
        }
        return item; // 其他情况直接返回
      });
    },
    onDepartmentList(list) {
      this.departmentList = list;
    },
    onDepartmentLabel(Label) {
      this.formSearch.departmentName = Label;
    },
    // 月 周 table
    getReportPage: function () {
      // this.formSearch.workClass = `${this.workClass}` === '0' ? '' : this.workClass;
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.$getJSON(apis.portalSiteDeviceWeekPage, { ...this.formSearch, departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '' }).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },

    // 清空标签
    onClear() {
      this.formSearch.customerName = '';
      this.formSearch.search = '';
      this.formSearch.departmentId = '';
      this.formSearch.departmentName = '';
      this.onPageChange({ page: 1 });
    },

    // 导出数据
    exportRecord: function () {
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.$exportFlie(apis.portalSiteDeviceWeekExport, { ...this.formSearch, departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '', excludeColumnList: this.filterArr }).then(() => { });
    },
    refreshPage() {
      this.getReportPage();
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getReportPage();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.usageweek-machine-list {
  .el-tabs .el-tabs__item {
    font-size: 14px;
  }

  .table-list {
    background: #ffffff;
    border-radius: 16px;
    padding: 24px 24px 0;
    .header {

      // padding: 24px;
      .label {
        color: #1a1a1a;
        line-height: 40px;
        font-weight: bold;
        float: left;
      }

      .search-content {
        float: right;
      }

      .icon-filter {
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        font-size: 16px;
        width: 40px;
        height: 40px;
        color: $--color-text-primary;
        box-shadow: 0 0 0 1.5px #202945 inset;
        border-radius: 50px;
        cursor: pointer;
      }
    }

    .title {
      height: 40px;
      font-size: 18px;
      font-weight: bold;
      color: #1a1a1a;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
    }

    .table-bd {
      background: #ffffff;
      border-radius: 16px;
      padding: 24px 24px 0;
      margin-top: 24px;
      width: 100%;
    }
  }
}
</style>
